import React from "react";

import ChatBot from "../../elements/chatbot/ChatBot";

export default function Chat() {
  return <ChatBot />;
}
